import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import { TicketsAttributes, PaymentTrip, PassengersDetails, DocumentType, CheckoutDocumentType } from 'store/types';
import { PassengerInformation, PassengerInformationBR } from 'components/checkout/models/checkout.model';

export function createTicketsAttributes(
  trips: PaymentTrip[],
  passengersInformation: PassengerInformation[],
): TicketsAttributes[] {
  return trips.flatMap((trip) => {
    const grouped = groupBy(trip.tickets, (ticket) => ticket.connectionIndex);

    return Object.values(grouped).flatMap((tickets) =>
      sortBy(tickets, ['passengerType', 'id']).map((ticket, i) => ({
        id: ticket.id,
        passengerName: `${passengersInformation[i].firstName} ${passengersInformation[i].lastName}`,
        passengerDocumentType: passengersInformation[i].passengerDocumentType,
        passengerDocumentNumber: passengersInformation[i].passengerDocumentNumber,
        passengerBirthDate: passengersInformation[i].passengerBirthDate,
        phoneNumber: passengersInformation[i].phoneNumber,
        documentType: passengersInformation[i].documentType,
        cpf: passengersInformation[i].cpf,
      })),
    );
  });
}

function convertDateFormat(dateString: string) {
  if (!dateString) return dateString;

  const parts = dateString.split('/');
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

export const getPassengersInformation = (
  trips: PaymentTrip[],
  passengersInformation: PassengerInformationBR[],
): PassengersDetails[] => {
  return trips.flatMap((trip) => {
    const grouped = groupBy(trip.tickets, (ticket) => ticket.connectionIndex);

    return Object.values(grouped).flatMap((tickets) =>
      sortBy(tickets, ['passengerType', 'id']).map((ticket, i) => ({
        ticketId: ticket.id,
        seatIdentifier: '',
        firstName: passengersInformation[i].firstName,
        lastName: passengersInformation[i].lastName,
        documentNumber: passengersInformation[i].passengerDocumentNumber,
        documentType: passengersInformation[i]?.documentType,
        passengerBirthDate: convertDateFormat(passengersInformation[i]?.passengerBirthDate),
        cpf: passengersInformation[i]?.cpf,
        phone: passengersInformation[i]?.phoneNumber,
      })),
    );
  });
};
